export default __webpack_public_path__ + "static/media/IconPlusActive.2fa38c45.svg";